import { getAnon, getUser } from "../helper/http";

export interface AuthSettings {
  signUpOpen: boolean;
  resetOpen: boolean;
  tgBot: string;
}

export interface MenuItem {
  path: string;
  name: string;
}

export interface DashboardModule {
  id: number;
  name: string;
  table_name: string;
  order: number;
  list_field_id?: number | null;
  sort_field_id?: number | null;
  access?: string;
  created_at?: string;
  is_system?: boolean;
  favorite?: number;
}

export interface MenuSettings {
  modules: DashboardModule[];
  dashboard?: { id: number; name: string; key: string; access: string }[];
  reports?: {id: number, name: string}[];
}

export class SettingsService {
  static async getAuthSettings(): Promise<AuthSettings> {
    const res = await getAnon("settings/auth-settings");
    return res;
  }

  static async getMenuSettings(): Promise<MenuSettings> {
    const res = await getUser("settings/menu-settings");
    return res;
  }
}